import { ApiProperty } from "@nestjs/swagger";



export class AssetCheckListDto {
    @ApiProperty()
    checkListid: number;

    // @ApiProperty()
    // assetCategory : string;

    // @ApiProperty()
    // assetName : string;

    @ApiProperty()
    checkListName : string;

    @ApiProperty()
    assetId : number;

    @ApiProperty()
    assetCategoryId : string;

    @ApiProperty()
    subName: string;
    @ApiProperty()
    model :string
    @ApiProperty()
    isActive: boolean;
    
    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;
}